import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestionnaireHuge = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 50,
			cy: 50,
			r: 50,
			fill: "#FFF6E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.7857 26.7863C26.7857 24.8138 28.3847 23.2148 30.3571 23.2148H69.6429C71.6153 23.2148 73.2143 24.8138 73.2143 26.7863V73.2148C73.2143 75.1873 71.6153 76.7863 69.6429 76.7863H30.3571C28.3847 76.7863 26.7857 75.1873 26.7857 73.2148V26.7863Z",
			fill: "#FBD68B"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M64.7861 38.3934H35.2139C34.507 38.3934 33.9286 37.815 33.9286 37.1081V37.0003C33.9286 36.2933 34.507 35.7148 35.2139 35.7148H64.7861C65.493 35.7148 66.0714 36.2933 66.0714 37.0003V37.1081C66.0714 37.815 65.493 38.3934 64.7861 38.3934Z",
			fill: "#D38702"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M64.7861 45.534H35.2139C34.507 45.534 33.9286 44.9556 33.9286 44.2487V44.1409C33.9286 43.4339 34.507 42.8555 35.2139 42.8555H64.7861C65.493 42.8555 66.0714 43.4339 66.0714 44.1409V44.2487C66.0714 44.9556 65.493 45.534 64.7861 45.534Z",
			fill: "#D38702"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M64.7861 52.6786H35.2139C34.507 52.6786 33.9286 52.1002 33.9286 51.3933V51.2854C33.9286 50.5784 34.507 50 35.2139 50H64.7861C65.493 50 66.0714 50.5784 66.0714 51.2854V51.3933C66.0714 52.1002 65.493 52.6786 64.7861 52.6786Z",
			fill: "#D38702"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M64.7861 59.8231H35.2139C34.507 59.8231 33.9286 59.2447 33.9286 58.5378V58.43C33.9286 57.7229 34.507 57.1445 35.2139 57.1445H64.7861C65.493 57.1445 66.0714 57.7229 66.0714 58.43V58.5378C66.0714 59.2447 65.493 59.8231 64.7861 59.8231Z",
			fill: "#D38702"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M50.5004 66.9637H35.2139C34.507 66.9637 33.9286 66.3853 33.9286 65.6784V65.5706C33.9286 64.8636 34.507 64.2852 35.2139 64.2852H50.5004C51.2073 64.2852 51.7857 64.8636 51.7857 65.5706V65.6784C51.7857 66.3853 51.2073 66.9637 50.5004 66.9637Z",
			fill: "#D38702"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.4643 20.5346C54.4643 18.069 52.4656 16.0703 50 16.0703C47.5344 16.0703 45.5357 18.069 45.5357 20.5346H39.5112C38.4005 20.5346 37.5 21.4366 37.5 22.549V27.6775H62.5V22.549C62.5 21.4366 61.5996 20.5346 60.4888 20.5346H54.4643Z",
			fill: "#8D4A05"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M51.7857 20.5357C51.7857 21.5219 50.9862 22.3214 49.9999 22.3214C49.0137 22.3214 48.2143 21.5219 48.2143 20.5357C48.2143 19.5496 49.0137 18.75 49.9999 18.75C50.9862 18.75 51.7857 19.5496 51.7857 20.5357Z",
			fill: "#F6A500"
		})
	]
});
export default SvgQuestionnaireHuge;
